import React from "react";
import { Row, Col } from "react-flexbox-grid";
// SCSS
import "./hero.scss";
//Assets
import HeroImage from '../../assets/hero/hero-image.jpeg';
//Components
import Button from '../ui-components/button/button';
import ResumeButton from "./resumeButton.jsx";
const hero = () => (
  <div className="hero" id="hero">
    <div className="wrapper">
      <Row>
        <Col md={12} lg={6}>
          <div className="hero-info">
            <h1 className="weight800 font60">Hello!</h1>
            <h1 className="weight800 font60">
              My name is Labib Rahman.
            </h1>
            <p className="font12" fontSize= "large">
              I am a Computer Science and Engineering graduate from North South University with a keen interest in software engineering.
            </p>
            <div >
            <Button label="SEND MESSAGE" target={"contact"} />
            <br></br>
            <br></br>
            <ResumeButton label="RESUME" target="https://drive.google.com/file/d/1iTJNbxNmgXzdhKdgfR5wZ7KAiurMhCts/view?usp=sharing" onClick={()=> window.open("", "_blank")} />
            </div>
           
           
            
          </div>
        </Col>
        <Col md={12} lg={6}>
          <div className="hero-image">
            <img  src={HeroImage} alt="hero" />
          </div>
         
        </Col>
        
      </Row>
    </div>
  </div>
);

export default hero;
